import React from "react";
import styled from "styled-components";
import LogoImage from "../../atoms/Utlis/LogoImage";
import { useNavigate } from "react-router-dom";
import { device } from "../../atoms/Utlis/media";
import { getWhiteLableObject } from "../../../config/whitelable";
import kwikMemoriesLogoIcon from "../../../assets/Icons/login/KM_whitelogo.webp";

const LogoContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    justify-content: center;
    align-items: center;
  }
`;

const CustomLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
`;

const CustomLogoText = styled.span`
  font-family: 'Urbanist', sans-serif;
  font-weight: 900;
  font-size: 28px;
  line-height: 100%;
  color: #000000;
  letter-spacing: 0%;
`;

const CustomLogoIcon = styled.img`
  width: 68px;
  height: auto;
  object-fit: contain;
`;

const CompanyLogo: React.FC = () => {
  const navigate = useNavigate();
  const wl = getWhiteLableObject();

  if (wl.key === "default" || wl.key === "locahost") {
    return (
      <CustomLogoWrapper onClick={() => navigate("/dashboard/")}>
        <CustomLogoIcon src={kwikMemoriesLogoIcon} alt="Kwik Memories" />
        <CustomLogoText>Kwik Memories</CustomLogoText>
      </CustomLogoWrapper>
    );
  }

  return (
    <LogoContainer onClick={() => navigate("/dashboard/")}>
      <LogoImage />
      {/* {getWhiteLableObject().isShowingName === true ? <LogoText>{getWhiteLableObject().name}</LogoText> : ""} */}
      {getWhiteLableObject().key !== "default" && (
        <div className="z-50 text-[14px] flex items-center gap-1 font-semibold text-white">
          Powered By{" "}
          <div className="flex flex-col items-center">
            <img src="/logos/KM_whitelogo.webp" className="h-[40px] w-[40px]" />
            <div className="text-[10px] text-white">KwikMemories</div>
          </div>
        </div>
      )}
    </LogoContainer>
  );
};

export default CompanyLogo;
